module.exports = __webpack_public_path__ + "static/05-11602b6643af9c05b02611ce4c266b33.jpg";